import { IPhoneNumber } from "../vue-interfaces/i-phone-number";
import { IAddress } from "../vue-interfaces/i-address";
import { Address } from "./address";

export class Pharmacy {
    public Id: string = "";
    public Name: string = "";
    public Address: IAddress = new Address();
    public PhoneNumbers: IPhoneNumber[] = [
        {
            number: "",
            extension: "",
            type: 0,
            country: "",
            isPrimary: true
        }
    ];
    public ContactFirstName?: string = "";
    public ContactLastName?: string = "";
    public Email: string = "";
    public FaxNumber: string = "";
    public Comment: string = "";
    public LastUpdated: string;
    public AssociatedAgencyProviderIds: string[] = [];

    public constructor(data?: Pharmacy) {
        if (data) {
            Object.assign(this, data);
            this.Address = new Address(this.Address);
        }
    }
}
